import { BookingWizard } from "@/components/booking/BookingWizard";
import { OrderStatusPage } from "@/features/booking/OrderStatusPage";
import { wasteKingAssets } from "@/lib/siteAssets";

export function App() {
  const orderMatch = window.location.pathname.match(/^\/orders\/([^/]+)\/?$/);

  if (orderMatch) {
    return <OrderStatusPage bookingReference={decodeURIComponent(orderMatch[1])} />;
  }

  return (
    <main className="min-h-screen bg-background text-foreground">
      <div className="mx-auto flex min-h-screen w-full max-w-7xl flex-col px-4 py-5 sm:px-6 lg:px-8">
        <header className="mb-6 flex flex-col gap-4 rounded-lg bg-accent px-5 py-4 text-accent-foreground shadow-[0_18px_45px_hsl(229_61%_34%_/_0.18)] sm:flex-row sm:items-center sm:justify-between">
          <img src={wasteKingAssets.logos.blue} alt="Waste King" className="h-auto w-40" />
          <div className="max-w-2xl">
            <h1 className="text-2xl font-black tracking-normal text-white sm:text-3xl">Online booking</h1>
            <p className="mt-1 text-sm text-white/78">
              Book skips, man-and-van collections, and grab hire with saved progress and live-style pricing.
            </p>
          </div>
        </header>
        <BookingWizard />
      </div>
    </main>
  );
}
